import { Divider } from "antd";
import React from "react";
import ChannelsPageServiceTitle from "./ChannelsPageServiceTitle";
import ConfigPhone from "./ConfigPhone";
import VoiceConfigPhone from "./VoiceConfigPhone";

//Please make sure if you do any UI changes here, you also update the <Step1/> in TextSMSAuthPage.jsx
const Step2 = ({ rightServiceObj, setRightServiceObj, setShowFinishButton, campaignStatus }) => {
  const pathname = window.location.pathname;

  return (
    <div className="d-grid gap-2">
      {!pathname.includes("voice") ? (
        <ConfigPhone
          rightServiceObj={rightServiceObj}
          setRightServiceObj={setRightServiceObj}
          setShowFinishButton={setShowFinishButton}
          campaignStatus={campaignStatus}
        />
      ) : (
        <VoiceConfigPhone rightServiceObj={rightServiceObj} setShowFinishButton={setShowFinishButton} />
      )}
    </div>
  );
};

export default Step2;
